var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"de3a42611a6b56e7ccca36effcd9d94c6da7e17c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["customer-portal@bundle-yz"]={id:"de3a42611a6b56e7ccca36effcd9d94c6da7e17c"};
      